// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3qtCY","footer":"ModalInfo_footer__vCATg"};